module.exports = __webpack_public_path__ + "front/img/btn2_2.8d91106c.png";